/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const STYLES_FLEX_ROW_LAYOUT = `
  :host {
    display: flex;
    flex-direction: row;
  }
`;

export const STYLES_FLEX_COLUMN_LAYOUT = `
  :host {
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
`;

export const STYLES_DIALOG_LAYOUT = `
  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const STYLES_FLEX_SPACE_BETWEEN = `
  :host {
    justify-content: space-between;
  }
`;

export const STYLES_FLEX_CROSS_CENTER = `
  :host {
    align-items: center;
  }
`;

export const STYLES_FULL_HEIGHT = `
  :host {
    height: 100%;
  }
`;

export const STYLES_DISPLAY_NONE = `
  :host {
    display: none;
  }
`;

export const STYLES_COMPACT_TEXTAREA_EDITOR = `
  ::ng-deep gh-grid-textarea-cell-editor {
    min-width: 300px !important;
    width: 300px !important;
    border-radius: 8px !important;
    overflow: hidden !important;
  }

  ::ng-deep gh-grid-textarea-cell-editor .textarea-input-wrapper {
    border-radius: 8px !important;
    padding: 6px !important;
  }

  ::ng-deep gh-grid-textarea-cell-editor textarea.cell-input {
    border-radius: 6px !important;
    padding: 8px !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    min-height: 60px !important;
    max-height: 80px !important;
  }
`;
